const getFeaturesFromArray = (
  features,
  filter = datum => datum,
  map = datum => datum
) => {
  if (!features) {
    return []
  }

  const data = features
        .map(feature => feature.properties)
        .filter(filter)
        .map(map)

  return data
}

export default getFeaturesFromArray



// WEBPACK FOOTER //
// ./src/utility/getFeaturesFromArray.js